import { i18n } from "../../../lang/lang.js";
import { appConfig } from "./AppConfig";

class MesssageUtil {
  /**
   * 指定のIDのメッセージを返します。
   * @param {String} messageId
   * @param {Array<String>} args
   * @returns {String}
   */
  getMessage(messageId, args) {
    const messageObj = this.getMessageObj(messageId);
    if (messageObj) {
      let message = messageObj.message;
      if (args) {
        args.forEach((arg, idx) => {
          message = message.replaceAll("{" + idx + "}", arg);
        });
      }
      return message;
    }
    return null;
  }

  /**
   * API実行時例外が発生した際のエラーメッセージを返却する
   *
   * @returns {String}
   * - "APIを実行した際にシステムエラーが発生しました。"
   * - ""（メッセージ取得に失敗した場合）
   *   - 言語.jsonファイルにいるのでありえないが、String返却したいのでこの形
   */
  getMessageSystemError() {
    return this.getMessage("P-999-999_999_E") || "";
  }

  /**
   * 指定のメッセージの埋め文字を埋める
   */
  fillMessagePadding(targetMessage, args) {
    let message = targetMessage ?? "";
    if (args) {
      args.forEach((arg, idx) => {
        message = message.replaceAll("{" + idx + "}", arg);
      });
    }
    return message;
  }
  getResMessage(resCom) {
    let message = "";
    if (resCom) {
      if (resCom.resComMessageId == null) {
        message = resCom.resComMessages["resComMessage" + sessionStorage.getItem("lang")];
      } else {
        message = i18n.tc("message.errorCode");
      }
    } else {
      message = i18n.tc("message.errorCode");
    }
    return message;
  }

  /**
   * 指定のIDのメッセージオブジェクトを返します。
   * @param {String} messageId
   * @returns {Json}
   */
  getMessageObj(messageId) {
    const searchRule = function (obj) {
      if (obj.id == messageId) {
        return true;
      }
      return false;
    };
    return this.messageList.find(searchRule);
  }

  messageList = [
    {
      id: "P-COM-001_001_E",
      level: "error",
      message: i18n.t("error.P-COM-001_001_E"),
    },
    { id: "P-COM-001_002_E", level: "error", message: i18n.t("error.P-COM-001_002_E") },
    {
      id: "P-COM-001_003_E",
      level: "error",
      message: i18n.t("error.P-COM-001_003_E"),
    },
    {
      id: "P-COM-001_003_W",
      level: "success",
      message: i18n.t("message.P-COM-001_003_W"),
    },

    {
      id: "P-COM-001_004_W",
      level: "success",
      message: i18n.t("message.P-SHP-004_002_W"),
    },
    {
      id: "P-COM-001_005_C",
      level: "success",
      message: i18n.t("message.P-COM-001_005_C"),
    },
    {
      id: "P-COM-001_006_C",
      level: "success",
      message: i18n.t("message.P-COM-001_006_C"),
    },
    {
      id: "A-999-999_001_I",
      level: "success",
      message: i18n.t("message.A-999-999_001_I"),
    },
    {
      id: "A-999-999_025_E",
      level: "success",
      message: i18n.t("message.A-999-999_025_E"),
    },
    {
      id: "P-COM-001_007_E",
      level: "error",
      message: i18n.t("error.P-COM-001_007_E"),
    },
    {
      id: "P-COM-001_008_C",
      level: "success",
      message: i18n.t("message.P-COM-001_008_C"),
    },
    {
      id: "P-COM-001_008_E",
      level: "error",
      message: i18n.t("error.P-COM-001_008_E"),
    },
    {
      id: "P-COM-001_009_E",
      level: "error",
      message: i18n.t("error.P-COM-001_009_E"),
    },
    {
      id: "P-COM-001_010_E",
      level: "error",
      message: i18n.t("error.P-COM-001_010_E"),
    },
    {
      id: "P-COM-131_001_C",
      level: "success",
      message: i18n.t("message.P-COM-131_001_C"),
    },
    {
      id: "P-COM-131_002_C",
      level: "success",
      message: i18n.t("message.P-COM-131_002_C"),
    },
    {
      id: "P-999-999_999_E",
      level: "error",
      message: i18n.t("error.A-999-999_001_E"),
    },
    {
      id: "A-999-999_999_E",
      level: "error",
      message: i18n.t("error.A-999-999_001_E"),
    },
    {
      id: "A-999-999_001_E",
      level: "error",
      message: i18n.t("error.A-999-999_001_E"),
    },
    {
      id: "P-999-999_999_E",
      level: "error",
      message: i18n.t("error.A-999-999_001_E"),
    },
    {
      id: "P-RCV-001_001_C",
      level: "success",
      message: i18n.t("message.P-RCV-001_001_C"),
    },
    {
      id: "P-RCV-001_002_W",
      level: "error",
      message: i18n.t("error.P-RCV-001_002_W"),
    },
    {
      id: "P-RCV-001_003_C",
      level: "success",
      message: i18n.t("message.P-RCV-001_003_C"),
    },
    {
      id: "P-RCV-001_004_C",
      level: "success",
      message: i18n.t("message.P-RCV-001_004_C"),
    },
    {
      id: "P-RCV-001_005_E",
      level: "error",
      message: i18n.t("error.P-RCV-001_005_E"),
    },
    {
      id: "P-RCV-001_006_E",
      level: "error",
      message: i18n.t("error.P-RCV-001_006_E"),
    },
    {
      id: "P-TOD-001_001_E",
      level: "error",
      message: i18n.t("error.P-TOD-001_001_E"),
    },
    {
      id: "P-RCV-001_007_E",
      level: "error",
      message: i18n.t("error.P-RCV-001_007_E"),
    },
    {
      id: "P-RCV-004_001_C",
      level: "success",
      message: i18n.t("message.P-RCV-004_001_C"),
    },
    {
      id: "P-RCV-004_002_C",
      level: "success",
      message: i18n.t("message.P-SHP-004_001_C"),
    },
    {
      id: "P-RCV-004_003_W",
      level: "success",
      message: i18n.t("message.P-SHP-004_002_W"),
    },
    {
      id: "P-EXT-005_001_C",
      level: "success",
      message: i18n.t("message.P-EXT-005_001_C"),
    },
    {
      id: "P-EXT-005_002_C",
      level: "success",
      message: i18n.t("message.P-EXT-005_002_C"),
    },
    {
      id: "P-ENT-004_001_C",
      level: "success",
      message: i18n.t("message.P-SHP-004_001_C"),
    },
    {
      id: "P-ENT-004_002_W",
      level: "success",
      message: i18n.t("message.P-SHP-004_002_W"),
    },
    {
      id: "P-SHP-012_001_C",
      level: "success",
      message: i18n.t("message.P-SHP-012_001_C"),
    },
    {
      id: "P-SHP-004_001_C",
      level: "success",
      message: i18n.t("message.P-SHP-004_001_C"),
    },
    {
      id: "P-SHP-004_002_W",
      level: "success",
      message: i18n.t("message.P-SHP-004_002_W"),
    },
    {
      id: "P-SHP-003_001_E",
      level: "success",
      message: i18n.t("message.P-SHP-003_001_E"),
    },
    {
      id: "P-SHP-003_002_E",
      level: "error",
      message: i18n.t("error.P-SHP-003_002_E"),
    },
    {
      id: "P-SHP-010_001_C",
      level: "success",
      message: i18n.t("message.P-SHP-010_001_C"),
    },
    {
      id: "P-SHP-010_001_E",
      level: "error",
      message: i18n.t("error.P-BIL-005_001_E"),
    },
    {
      id: "P-SHP-010_001_01-01",
      level: "error",
      message: i18n.t("error.P-SHP-010_001_01-01"),
    },
    {
      id: "P-SHP-010_001_01-02",
      level: "error",
      message: i18n.t("error.P-SHP-010_001_01-02"),
    },
    {
      id: "P-SHP-010_001_01-03",
      level: "error",
      message: i18n.t("error.P-SHP-010_001_01-03"),
    },
    {
      id: "P-SHP-010_001_01-04",
      level: "error",
      message: i18n.t("error.P-SHP-010_001_01-04"),
    },
    {
      id: "P-SHP-010_001_05",
      level: "error",
      message: i18n.t("error.P-SHP-010_001_05"),
    },
    {
      id: "P-SHP-010_001_06",
      level: "error",
      message: i18n.t("error.P-SHP-010_001_06"),
    },
    {
      id: "P-SHP-010_001_08",
      level: "error",
      message: i18n.t("error.P-SHP-010_001_08"),
    },
    {
      id: "P-SHP-010_001_09",
      level: "error",
      message: i18n.t("error.P-SHP-010_001_09"),
    },
    {
      id: "P-SHP-010_001_99",
      level: "success",
      message: i18n.t("message.P-SHP-010_001_99"),
    },
    {
      id: "P-SHP-010_001_310",
      level: "success",
      message: i18n.t("message.P-SHP-010_001_310"),
    },
    {
      id: "P-SHP-010_001_400",
      level: "success",
      message: i18n.t("message.P-SHP-010_001_400"),
    },
    {
      id: "P-SHP-010_001_999",
      level: "success",
      message: i18n.t("message.P-SHP-010_001_999"),
    },
    {
      id: "P-TMP-903_001_E",
      level: "error",
      message: i18n.t("error.P-TMP-903_001_E"),
    },
    {
      id: "P-TMP-903_002_E",
      level: "error",
      message: i18n.t("error.P-TMP-903_002_E"),
    },
    {
      id: "P-TMP-903_003_E",
      level: "error",
      message: i18n.t("error.P-TMP-903_003_E"),
    },
    {
      id: "P-TMP-909_001_C",
      level: "success",
      message: i18n.t("message.P-TMP-909_001_C"),
    },
    {
      id: "P-TMP-903_003_E",
      level: "error",
      message: i18n.t("error.P-EXT-001_001_E"),
    },
    {
      id: "P-TMP-903_004_E",
      level: "error",
      message: i18n.t("error.P-TMP-903_004_E"),
    },
    {
      id: "P-TMP-903_005_E",
      level: "error",
      message: i18n.t("error.P-TMP-903_005_E"),
    },
    {
      id: "P-MOV-002_001_E",
      level: "success",
      message: i18n.t("message.P-MOV-002_001_E"),
    },
    {
      id: "P-EXT-003_001_E",
      level: "error",
      message: i18n.t("error.P-EXT-003_001_E"),
    },
    {
      id: "P-RCV-006_001_E",
      level: "error",
      message: i18n.t("error.P-RCV-006_001_E"),
    },
    {
      id: "P-RCV-006_003_E",
      level: "error",
      message: i18n.t("error.P-RCV-006_003_E"),
    },
    {
      id: "P-RCV-006_004_E",
      level: "error",
      message: i18n.t("error.P-RCV-006_004_E"),
    },
    {
      id: "P-RCV-007_001_C",
      level: "success",
      message: i18n.t("message.P-RCV-007_001_C"),
    },
    {
      id: "P-MST-009_001_E",
      level: "success",
      message: i18n.t("message.P-MST-009_001_E"),
    },
    {
      id: "P-MST-009_002_E",
      level: "success",
      message: i18n.t("message.P-MST-009_002_E"),
    },
    {
      id: "P-MST-001_001_E",
      level: "error",
      message: i18n.t("error.P-MST-001_001_E"),
    },
    {
      id: "P-MST-001_001_I",
      level: "success",
      message: i18n.t("message.P-MST-001_001_I"),
    },
    {
      id: "P-MST-001_002_I",
      level: "success",
      message: i18n.t("message.P-MST-001_002_I"),
    },
    {
      id: "P-MST-001_003_I",
      level: "success",
      message: i18n.t("message.P-MST-001_003_I"),
    },
    {
      id: "P-MST-014_001_C",
      level: "success",
      message: i18n.t("message.P-MST-014_001_C"),
    },
    {
      id: "P-MST-014_002_E",
      level: "error",
      message: i18n.t("error.P-MST-014_002_E"),
    },
    {
      id: "P-EXT-001_001_E",
      level: "error",
      message: i18n.t("error.P-EXT-001_001_E"),
    },
    {
      id: "P-MST-009_003_E",
      level: "error",
      message: `${appConfig.CONSTANT.BATCH}${i18n.t("error.P-MST-009_003_E")}`,
    },
    {
      id: "P-MST-009_004_E",
      level: "error",
      message: `${appConfig.CONSTANT.LOCATIONMAXADD}${i18n.t("error.P-MST-009_003_E")}`,
    },
    {
      id: "P-BIL-001_001_E",
      level: "sucess",
      message: i18n.t("message.P-BIL-001_001_E"),
    },
    {
      id: "P-BIL-003_001_C",
      level: "sucess",
      message: i18n.t("message.P-BIL-003_001_C"),
    },
    {
      id: "P-BIL-003_002_E",
      level: "sucess",
      message: i18n.t("message.P-BIL-003_002_E"),
    },
    {
      id: "P-BIL-003_003_C",
      level: "sucess",
      message: i18n.t("message.P-BIL-003_003_C"),
    },
    {
      id: "P-BIL-003_004_E",
      level: "sucess",
      message: i18n.t("message.P-BIL-003_004_E"),
    },
    {
      id: "P-BIL-003_005_E",
      level: "error",
      message: i18n.t("error.P-BIL-003_005_E"),
    },
    {
      id: "P-BIL-004_001_E",
      level: "error",
      message: i18n.t("error.P-BIL-004_001_E"),
    },
    {
      id: "P-BIL-005_001_E",
      level: "error",
      message: i18n.t("error.P-BIL-005_001_E"),
    },
    {
      id: "P-BIL-006_001_C",
      level: "sucess",
      message: i18n.t("message.P-BIL-006_001_C"),
    },
    {
      id: "P-MST-001_002_E",
      level: "error",
      message: i18n.t("error.P-MST-001_002_E"),
    },
    {
      id: "P-MST-001_003_E",
      level: "error",
      message: i18n.t("error.P-MST-001_003_E"),
    },
    {
      id: "P-MST-001_004_E",
      level: "error",
      message: i18n.t("error.P-MST-001_004_E"),
    },
    {
      id: "P-MST-001_005_E",
      level: "error",
      message: i18n.t("error.P-MST-001_005_E"),
    },
    {
      id: "P-MST-001_006_E",
      level: "error",
      message: i18n.t("error.P-MST-001_006_E"),
    },
    {
      id: "P-MST-001_007_E",
      level: "error",
      message: i18n.t("error.P-MST-001_007_E"),
    },
    {
      id: "P-MST-001_008_E",
      level: "error",
      message: i18n.t("error.P-MST-001_008_E"),
    },
    {
      id: "P-MST-001_009_E",
      level: "error",
      message: i18n.t("error.P-MST-001_009_E"),
    },
    {
      id: "A-999-999_004_E",
      level: "error",
      message: i18n.t("error.A-999-999_004_E"),
    },
    {
      id: "P-ENT-001_001_E",
      level: "error",
      message: i18n.t("error.P-ENT-001_001_E"),
    },
    {
      id: "P-CNT-006_001_E",
      level: "success",
      message: i18n.t("message.P-CNT-006_001_E"),
    },
    {
      id: "P-ENT-002_001_E",
      level: "error",
      message: i18n.t("error.P-ENT-002_001_E"),
    },
    {
      id: "P-ENT-002_003_E",
      level: "error",
      message: i18n.t("error.P-ENT-002_003_E"),
    },
    {
      id: "P-RTN-001_001_E",
      level: "error",
      message: i18n.t("error.P-RTN-001_001_E"),
    },
    {
      id: "P-RTN-001_002_E",
      level: "error",
      message: i18n.t("error.P-RTN-001_002_E"),
    },
    {
      id: "P-RTN-001_003_E",
      level: "error",
      message: i18n.t("error.P-RTN-001_003_E"),
    },
    {
      id: "P-ENT-002_002_E",
      level: "error",
      message: i18n.t("error.P-ENT-002_002_E"),
    },
    {
      id: "P-CNT-006_002_C",
      level: "success",
      message: i18n.t("message.P-CNT-006_002_C"),
    },
    {
      id: "P-CNT-006_003_C",
      level: "error",
      message: i18n.t("error.P-CNT-006_003_C"),
    },
    {
      id: "P-CNT-006_004_C",
      level: "error",
      message: i18n.t("error.P-CNT-006_004_C"),
    },
    {
      id: "P-CNT-006_005_E",
      level: "error",
      message: i18n.t("error.P-CNT-006_005_E"),
    },
    {
      id: "P-RTN-002_001_E",
      level: "error",
      message: i18n.t("error.P-RTN-002_001_E"),
    },
    {
      id: "P-RTN-003_001_E",
      level: "success",
      message: i18n.t("message.P-RTN-003_001_E"),
    },
    {
      id: "P-RCV-006_002_E",
      level: "error",
      message: i18n.t("error.P-RCV-006_002_E"),
    },
    {
      id: "P-CNT-006_002_3",
      level: "success",
      message: i18n.t("message.P-CNT-006_002_3"),
    },
    {
      id: "P-STK-001_001_E",
      level: "error",
      message: i18n.t("error.P-STK-001_001_E"),
    },
    {
      id: "P-STK-001_002_E",
      level: "error",
      message: i18n.t("error.P-STK-001_002_E"),
    },
    {
      id: "P-STK-001_003_E",
      level: "error",
      message: i18n.t("error.P-STK-001_003_E"),
    },
    {
      id: "P-STK-001_004_E",
      level: "error",
      message: i18n.t("error.P-STK-001_004_E"),
    },
    {
      id: "P-STK-001_005_E",
      level: "error",
      message: i18n.t("error.P-STK-001_005_E"),
    },
    {
      id: "P-STK-002_001_E",
      level: "error",
      message: i18n.t("error.P-STK-002_001_E"),
    },
    {
      id: "P-STK-002_002_E",
      level: "error",
      message: i18n.t("error.P-STK-002_002_E"),
    },
    {
      id: "P-EXT-003_002_E",
      level: "error",
      message: i18n.t("error.P-EXT-003_002_E"),
    },
    {
      id: "P-MST-006_001_C",
      level: "success",
      message: i18n.t("message.P-MST-006_001_C"),
    },
    {
      id: "P-MST-006_001_E",
      level: "success",
      message: i18n.t("message.P-MST-006_001_E"),
    },
    {
      id: "P-STK-002_003_E",
      level: "success",
      message: i18n.t("message.P-STK-002_003_E"),
    },
    {
      id: "P-STK-004_001_E",
      level: "error",
      message: i18n.t("error.P-STK-004_001_E"),
    },
    {
      id: "P-MST-006_002_E",
      level: "success",
      message: i18n.t("message.P-MST-006_002_E"),
    },
    {
      id: "P-MST-026_001_C",
      level: "success",
      message: i18n.t("message.P-MST-026_001_C"),
    },
    {
      id: "P-SUP-001_001_E",
      level: "success",
      message: i18n.t("message.P-SUP-001_001_E"),
    },
    {
      id: "P-SUP-001_002_E",
      level: "success",
      message: i18n.t("message.P-SUP-001_002_E"),
    },
    {
      id: "P-SUP-001_003_E",
      level: "error",
      message: i18n.t("error.P-SUP-001_003_E"),
    },
    {
      id: "P-SUP-020_001_C",
      level: "success",
      message: i18n.t("message.P-SUP-020_001_C"),
    },
    {
      id: "P-MST-006_003_E",
      level: "error",
      message: i18n.t("error.P-MST-006_003_E"),
    },
    {
      id: "P-MST-049_001_E",
      level: "error",
      message: i18n.t("error.P-MST-049_001_E"),
    },
    {
      id: "P-MST-049_002_E",
      level: "error",
      message: i18n.t("error.P-MST-049_002_E"),
    },
    {
      id: "P-MST-049_003_E",
      level: "error",
      message: i18n.t("error.P-MST-049_003_E"),
    },
    {
      id: "P-MNG-010_001_E",
      level: "error",
      message: i18n.t("error.P-MNG-010_001_E"),
    },
    {
      id: "P-MNG-010_002_E",
      level: "error",
      message: i18n.t("error.P-MNG-010_002_E"),
    },
    {
      id: "P-STC-001_002_E",
      level: "error",
      message: i18n.t("error.P-STC-001_002_E"),
    },
    {
      id: "P-STC-001_003_E",
      level: "error",
      message: i18n.t("error.P-STC-001_003_E"),
    },
    // {
    //   id: "P-STC-001_004_E",
    //   level: "error",
    //   message: "選択されたデータは実績登録済みです。",
    // },
    {
      id: "P-STC-001_004_E",
      level: "error",
      message: i18n.t("error.P-STC-001_004_E"),
    },
    {
      id: "P-STC-001_005_E",
      level: "error",
      message: i18n.t("error.P-STC-001_005_E"),
    },
    {
      id: "P-CNT-004_001_E",
      level: "error",
      message: i18n.t("error.P-CNT-004_001_E"),
    },
    {
      id: "P-WST-001_001_E",
      level: "error",
      message: i18n.t("error.P-WST-001_001_E"),
    },
    {
      id: "P-WST-001_002_E",
      level: "error",
      message: i18n.t("error.P-WST-001_002_E"),
    },
    {
      id: "P-WST-001_003_E",
      level: "error",
      message: i18n.t("error.P-WST-001_003_E"),
    },
    {
      id: "P-WST-001_004_E",
      level: "error",
      message: i18n.t("error.P-WST-001_004_E"),
    },
    {
      id: "P-STC-001_006_E",
      level: "error",
      message: i18n.t("error.P-STC-001_006_E"),
    },
    {
      id: "P-WST-001_005_E",
      level: "error",
      message: i18n.t("error.P-WST-001_005_E"),
    },
    {
      id: "P-WST-001_006_E",
      level: "error",
      message: i18n.t("error.P-WST-001_006_E"),
    },
    {
      id: "P_SRG_004_001_E",
      level: "error",
      message: i18n.t("error.P_SRG_004_001_E"),
    },
    {
      id: "P_SRG_005_001_E",
      level: "error",
      message: i18n.t("error.P_SRG_005_001_E"),
    },
    {
      id: "P-DST-001_001_C",
      level: "success",
      message: i18n.t("message.P-DST-001_001_C"),
    },
    {
      id: "P-MST-013_001_E",
      level: "error",
      message: i18n.t("error.P-MST-013_001_E"),
    },
    {
      id: "P-MST-013_002_E",
      level: "error",
      message: i18n.t("error.P-MST-013_002_E"),
    },
    {
      id: "P-MST-013_003_E",
      level: "error",
      message: i18n.t("error.P-MST-013_003_E"),
    },
    {
      id: "P-SUP-002_001_E",
      level: "error",
      message: i18n.t("error.P-SUP-002_001_E"),
    },
    {
      id: "P-SUP-002_002_E",
      level: "error",
      message: i18n.t("error.P-SUP-002_002_E"),
    },
    {
      id: "P-SUP-003_001_E",
      level: "error",
      message: i18n.t("error.P-SUP-003_001_E"),
    },
    {
      id: "P-SUP-003_002_E",
      level: "error",
      message: i18n.t("error.P-SUP-003_002_E"),
    },
    {
      id: "P-SUP-017_001_E",
      level: "error",
      message: i18n.t("error.P-SUP-017_001_E"),
    },
    {
      id: "P-SUP-017_002_E",
      level: "error",
      message: i18n.t("error.P-SUP-017_002_E"),
    },
    {
      id: "P-SUP-017_003_E",
      level: "error",
      message: i18n.t("error.P-SUP-017_003_E"),
    },
    {
      id: "P-SUP-017_004_E",
      level: "error",
      message: i18n.t("error.P-SUP-017_004_E"),
    },
    {
      id: "P-SUP-017_005_E",
      level: "error",
      message: i18n.t("error.P-SUP-017_005_E"),
    },
    {
      id: "P-SUP-017_006_E",
      level: "error",
      message: i18n.t("error.P-SUP-017_006_E"),
    },
    {
      id: "P-SUP-018_001_E",
      level: "error",
      message: i18n.t("error.P-SUP-018_001_E"),
    },
    {
      id: "P-SUP-019_001_E",
      level: "error",
      message: i18n.t("error.P-SUP-019_001_E"),
    },
    {
      id: "P-SUP-020_001_E",
      level: "error",
      message: i18n.t("error.P-SUP-020_001_E"),
    },
    {
      id: "P-SUP-020_002_E",
      level: "error",
      message: i18n.t("error.P-SUP-020_002_E"),
    },
    {
      id: "P-DST-001_002_E",
      level: "success",
      message: i18n.t("message.P-DST-001_002_E"),
    },
    {
      id: "P-DST-001_003_C",
      level: "success",
      message: i18n.t("message.P-DST-001_003_C"),
    },
    {
      id: "P-DST-001_004_S",
      level: "success",
      message: i18n.t("message.P-DST-001_004_S"),
    },
    {
      id: "P-DST-001_005_E",
      level: "error",
      message: i18n.t("error.P-DST-001_005_E"),
    },
    {
      id: "P-DST-002_001_E",
      level: "error",
      message: i18n.t("error.P-DST-002_001_E"),
    },
    {
      id: "P-DST-002_002_E",
      level: "error",
      message: i18n.t("error.P-DST-002_002_E"),
    },
    {
      id: "P-INI-001_001_E",
      level: "error",
      message: i18n.t("error.P-INI-001_001_E"),
    },
    {
      id: "P-INI-003_001_E",
      level: "error",
      message: i18n.t("error.P-INI-003_001_E"),
    },
    {
      id: "P-INI-006_001_E",
      level: "error",
      message: i18n.t("error.P-INI-006_001_E"),
    },
    {
      id: "P-INI-008_001_E",
      level: "error",
      message: i18n.t("error.P-INI-008_001_E"),
    },
    {
      id: "P-INI-008_002_E",
      level: "error",
      message: i18n.t("error.P-INI-008_002_E"),
    },
    {
      id: "P-INI-008_003_E",
      level: "error",
      message: i18n.t("error.P-INI-008_003_E"),
    },
    {
      id: "P-INI-008_004_E",
      level: "error",
      message: i18n.t("error.P-INI-008_004_E"),
    },
    {
      id: "P-INI-008_005_E",
      level: "error",
      message: i18n.t("error.P-INI-008_005_E"),
    },
    {
      id: "P-INI-008_006_E",
      level: "error",
      message: i18n.t("error.P-INI-008_006_E"),
    },
    {
      id: "P-INI-009_001_E",
      level: "error",
      message: i18n.t("error.P-INI-009_001_E"),
    },
    {
      id: "P-INI-009_002_E",
      level: "error",
      message: i18n.t("error.P-INI-009_002_E"),
    },
    {
      id: "P-INI-009_003_E",
      level: "error",
      message: i18n.t("error.P-INI-009_003_E"),
    },
    {
      id: "P-INI-009_004_E",
      level: "error",
      message: i18n.t("error.P-INI-009_004_E"),
    },
    {
      id: "P-INI-010_001_E",
      level: "error",
      message: i18n.t("error.P-INI-010_001_E"),
    },
    {
      id: "P-INI-010_002_E",
      level: "error",
      message: i18n.t("error.P-INI-010_002_E"),
    },
    {
      id: "P-INI-010_003_E",
      level: "error",
      message: i18n.t("error.P-INI-010_003_E"),
    },
    {
      id: "P-INI-010_004_E",
      level: "error",
      message: i18n.t("error.P-INI-010_004_E"),
    },
    {
      id: "P-DVP-001_001_W",
      level: "success",
      message: i18n.t("message.P-DVP-001_001_W"),
    },
    {
      id: "P-DVP-001_002_W",
      level: "success",
      message: i18n.t("message.P-DVP-001_002_W"),
    },
    {
      id: "P-DVP-001_003_W",
      level: "success",
      message: i18n.t("message.P-DVP-001_003_W"),
    },
    {
      id: "P-DVP-001_004_W",
      level: "success",
      message: i18n.t("message.P-DVP-001_004_W"),
    },
    {
      id: "P-DVP-001_005_W",
      level: "success",
      message: i18n.t("message.P-DVP-001_005_W"),
    },
    {
      id: "P-DVP-001_006_W",
      level: "success",
      message: i18n.t("message.P-DVP-001_006_W"),
    },
    {
      id: "P-DVP-001_007_W",
      level: "success",
      message: i18n.t("message.P-DVP-001_007_W"),
    },
    {
      id: "P-DVP-001_001_C",
      level: "success",
      message: i18n.t("message.P-DVP-001_001_C"),
    },
    {
      id: "P-DVP-001_002_C",
      level: "success",
      message: i18n.t("message.P-DVP-001_002_C"),
    },
    {
      id: "P-DVP-001_001_E",
      level: "error",
      message: i18n.t("error.P-DVP-001_001_E"),
    },
    {
      id: "P-DVP-001_002_E",
      level: "error",
      message: i18n.t("error.P-DVP-001_002_E"),
    },
    {
      id: "P-DVP-005_001_C",
      level: "success",
      message: i18n.t("message.P-DVP-005_001_C"),
    },
    {
      id: "P-DVP-005_002_S",
      level: "success",
      message: i18n.t("message.P-DVP-005_002_S"),
    },
    {
      id: "P-TOD-003_001_C",
      level: "success",
      message: i18n.t("message.P-TOD-003_001_C"),
    },
    {
      id: "P-TRN-001_001_E",
      level: "error",
      message: i18n.t("error.P-TRN-001_001_E"),
    },
    {
      id: "P-TRN-001_002_E",
      level: "error",
      message: i18n.t("error.P-TRN-001_002_E"),
    },
    {
      id: "P-TRN-001_003_E",
      level: "error",
      message: i18n.t("error.P-TRN-001_003_E"),
    },
    {
      id: "P-STK-001_001_01",
      level: "error",
      message: i18n.t("error.P-STK-001_001_01"),
    },
    {
      id: "P-MST-024_001_E",
      level: "error",
      message: i18n.t("error.P-MST-024_001_E"),
    },
    {
      id: "P-MST-024_002_E",
      level: "error",
      message: i18n.t("error.P-MST-024_002_E"),
    },
    {
      id: "P-MST-024_003_E",
      level: "error",
      message: i18n.t("error.P-MST-024_003_E"),
    },
    {
      id: "P-MST-024_004_E",
      level: "error",
      message: i18n.t("error.P-MST-024_004_E"),
    },
    {
      id: "P-SHP-011_001_C",
      level: "success",
      message: i18n.t("message.P-SHP-011_001_C"),
    },
  ];
}

export const messsageUtil = new MesssageUtil();
